import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { AuthenticationStore, AuthenticationState } from './authentication.store';

@Injectable({ providedIn: 'root' })
export class AuthenticationQuery extends Query<AuthenticationState> {

  constructor(protected store: AuthenticationStore) {
    super(store);
  }

}
